const agenturfinder = {
	// Vars
	filters: "",
	filterArray: [],
	companies: "",
	companyForm: "",
	filterArrayNames: [],
	filterArrayCompanies: [],
	firmenInput: "",
	bereichInput: "",
	selectionDisplay: "",
	filterArea: "",
	companyArea: "",
	contactForm: "",
	nextButton: "",
	selectedCompaniesText: "",
	selectedAreasText: "",
	language: "",
	
	// Methods
	init: () => {
		agenturfinder.filters = document.querySelectorAll('.agenturfinder__filter-item input')
		agenturfinder.companies = document.querySelectorAll('.agenturfinder__companies .company')
		agenturfinder.companyForm = document.getElementById('agenturfinder__form')
		agenturfinder.firmenInput = document.getElementById('input__selected-companies')
		agenturfinder.bereichInput = document.getElementById('input__selected-areas')
		agenturfinder.selectedAreasText = document.getElementById('selected__areas-text')
		agenturfinder.selectedCompaniesText = document.getElementById('selected__companies-text')
		agenturfinder.selectionDisplay = document.getElementById('filter--selektion')
		agenturfinder.filterArea = document.querySelector('.agenturfinder__filter')
		agenturfinder.companyArea = document.querySelector('.agenturfinder__companies')
		agenturfinder.contactForm = document.querySelector('.finder__contact-form')
		agenturfinder.nextButton = document.querySelector('.agenturfinder__companies .rectangle__button')
		agenturfinder.language = document.documentElement.lang

		agenturfinder.nextButton.style.display = "none"
	},

	displayFilters: () => {
		let text = `<strong>${agenturfinder.language === "en-GB" ? "Your selection:" : "Ihre Auswahl:"}</strong> `
		let showText = false
		agenturfinder.filterArray = []
		agenturfinder.filterArrayNames = []
		agenturfinder.filterArrayCompanies = []
		agenturfinder.filters.forEach(filter => {
			if (filter.checked) {
				showText = true
				text += `<span onclick="agenturfinder.removeFilter(this)" data-slug="${filter.name}">${filter.dataset.title} &times;</span>`
				agenturfinder.filterArray.push( filter.name )
				agenturfinder.filterArrayNames.push( filter.dataset.title )
			}
		})
		showText ? agenturfinder.selectionDisplay.innerHTML = text : agenturfinder.selectionDisplay.innerHTML = ""

		if (agenturfinder.filterArrayNames.length > 0) { agenturfinder.nextButton.style.display = "" }
		else { agenturfinder.nextButton.style.display = "none" }
		
		agenturfinder.getFilterResults()
	},

	removeFilter: el => {
		document.getElementById(`f_${el.dataset.slug}`).checked = false
		agenturfinder.displayFilters()
	},

	showNoResultMessage: () => {
		const message = document.createElement('div')
		const messageText = document.createElement('h4')

		message.id = 'noresults'
		messageText.innerHTML = `${agenturfinder.language === "en-US" ? "No matches found. Please send us an individual request." : "Keine passenenden Treffer gefunden. Stellen Sie gerne eine individuelle Anfrage"}`

		message.appendChild(messageText)
		agenturfinder.selectionDisplay.appendChild(message)
	 },

	getFilterResults: () => {

		agenturfinder.filterArrayCompanies = []
		agenturfinder.companies.forEach(company => {
			let showCompany = true
			company.classList.remove('inactive')
			company.classList.remove('active')
			
			agenturfinder.filterArray.some(el => { 
				console.log(el, company.dataset.leistungen);
				showCompany = company.dataset.leistungen.includes(el)
				return showCompany
			})

			if (!showCompany) {
				company.classList.add('inactive')
			} else {
				company.classList.add('active')
				agenturfinder.filterArrayCompanies.push( company.dataset.title )
				if (agenturfinder.filterArray.length === 0) {
					company.classList.remove('active')
				}
			}
		})

		let bereichstext
		let firmentext

		switch (agenturfinder.filterArrayNames.length) {
			case 0:
				bereichstext = agenturfinder.language ===  'en-US' ? 'No area selected' : 'Kein Bereich gewählt.'
				break
			case 1:
				bereichstext = agenturfinder.language ===  'en-US' ? 'Area searched: ' : 'Gesuchter Bereich: '
				break
				default:
				bereichstext = agenturfinder.language ===  'en-US' ? 'Areas searched: ' : 'Gesuchte Bereiche: '
		}
		switch (agenturfinder.filterArrayCompanies.length) {
			case 0:
				firmentext = agenturfinder.language === "en-US" ? 'No company found' : 'Kein Unternehmen gefunden.'
				break
			case 1:
				firmentext = agenturfinder.language === "en-US" ? 'Matching company: ' : 'Passendes Unternehmen: '
				break
			default:
				firmentext = agenturfinder.language === "en-US" ? 'Matching companies: ' : 'Passende Unternehmen: '
		}

		agenturfinder.bereichInput.value = bereichstext + agenturfinder.filterArrayNames.join(', ')
		agenturfinder.firmenInput.value = firmentext + agenturfinder.filterArrayCompanies.join(', ')
		agenturfinder.selectedAreasText.innerText = bereichstext + agenturfinder.filterArrayNames.join(', ')
		agenturfinder.selectedCompaniesText.innerText = firmentext + agenturfinder.filterArrayCompanies.join(', ')

		if (agenturfinder.filterArrayNames.length > 0 && agenturfinder.filterArrayCompanies.length === 0) {
			agenturfinder.showNoResultMessage()
		}
	},

	anfrageStep: step => {
		if (step === 2) {
			agenturfinder.filterArea.style.display = "none"
			agenturfinder.companyArea.style.display = "none"
			agenturfinder.contactForm.style.display = "block"
		}
		else {
			agenturfinder.filterArea.style.display = ""
			agenturfinder.companyArea.style.display = ""
			agenturfinder.contactForm.style.display = "none"
			
		}
	},
	
	showCompanyInfo: (logosrc, title, txt, imagesrc, color, link, agentur, more) => {

		const modal = document.createElement('section')
		const modalContent = document.createElement('div')
		const imageContainer = document.createElement('div')
		const logoContainer = document.createElement('div')
		const textContainer = document.createElement('div')

		const logo = document.createElement('img')
		
		const headline = document.createElement('h4')
		const text = document.createElement('p')
		const closeButton = document.createElement('span')
		
		modal.id = "companymodal"
		modalContent.classList.add('modal__content')
		imageContainer.classList.add('company__image')
		logoContainer.classList.add('company__logo')
		textContainer.classList.add('company__text')
		
		closeButton.innerHTML = '&times;'
		headline.innerHTML = title
		text.innerHTML = txt + `<br><a href="${link}">${more}</a>`

		logo.alt = agentur
		logo.src = logosrc

		closeButton.addEventListener('click', () => { agenturfinder.closeModal(modal) })
		window.addEventListener('keyup', (e) => { e.key === "Escape" && agenturfinder.closeModal(modal) })

		textContainer.style.backgroundColor = color
		textContainer.appendChild(headline)
		textContainer.appendChild(text)

		logoContainer.appendChild(logo)
		logoContainer.appendChild(closeButton)

		imageContainer.style.backgroundImage = `url('${imagesrc}')`

		if (imagesrc) {
			modalContent.appendChild(imageContainer)
		} else {
			modal.classList.add('modal__no-image')
		}
		modalContent.appendChild(logoContainer)
		modalContent.appendChild(textContainer)

		modal.appendChild(modalContent)

		document.body.appendChild(modal)
	},
	
	closeModal: el => {
		console.log(el);
		el.remove()
	 }
}

document.addEventListener('DOMContentLoaded', () => {
	if (document.getElementById('filter--selektion')) {
		agenturfinder.init();
	}
})

